import { render, staticRenderFns } from "./setList.vue?vue&type=template&id=8d1a0890&"
import script from "./setList.vue?vue&type=script&lang=js&"
export * from "./setList.vue?vue&type=script&lang=js&"
import style0 from "./setList.vue?vue&type=style&index=0&id=8d1a0890&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports